import { api } from "@lumberset/api-client";
import { HelpArticle } from "@lumberset/support-ui";
import { Container } from "@lumberset/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/help/$slug")({ component: ArticlePage });

function ArticlePage() {
  const { slug } = Route.useParams();
  const navigate = useNavigate();
  return (
    <Container className="px-6 py-6">
      <div className="mx-auto w-full max-w-3xl">
        <HelpArticle
          api={api}
          slug={slug}
          onOpenArticle={(next) => navigate({ to: "/help/$slug", params: { slug: next } })}
          onBack={() => navigate({ to: "/help" })}
        />
      </div>
    </Container>
  );
}
